/*
 * @Description: 
 * @Author: 诺
 * @Date: 2022-04-21 14:37:18
 * @LastEditors: 诺
 * @LastEditTime: 2022-04-21 14:37:18
 */

let AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext;
let audioCtx = AudioContext ? new AudioContext() : "";

let soundBuffer = {
  getBuffer(link) {
    return new Promise((resolve, reject) => {
      if (audioCtx) {
        let request = new XMLHttpRequest();
        request.open("GET", link, true);
        request.responseType = "arraybuffer";
        request.onload = function () {
          audioCtx.decodeAudioData(
            request.response,
            function (buffer) {
              resolve(buffer);
            },
            function (e) {
              console.log("reject");
              reject(e);
            }
          );
        };
        request.send();
      } else {
        reject("not support AudioContext");
      }
    });
  },
  createSound(buffer) {
    if (audioCtx.state != "running") {
      console.log("重启audioCtx");
      audioCtx.resume();
    }
    let analyser = audioCtx.createAnalyser();
    let gainNode = audioCtx.createGain();
    let source = audioCtx.createBufferSource();
    source.buffer = buffer;
    source.connect(analyser);
    analyser.connect(gainNode);
    gainNode.connect(audioCtx.destination);
    return source;
  },
  resume() {
    audioCtx.resume();
  },
};
export default soundBuffer;
